var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('div',{staticClass:"modifier-display"},[_vm._v(" "+_vm._s(_vm.modNumber)+" "),_c('div',{staticClass:"individual-mod"},[_vm._v(_vm._s('['+_vm.modText+']'))])]),(_vm.showPlus)?_c('span',[_c('FontAwesomeIcon',{attrs:{"icon":_vm.plusIcon}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }